import React from 'react';

import classes from './NoRecordFound.module.css'

const NoRecordFound = ({message = 'No information found'}) => {
    return (
        <label className={classes['']} >{message}</label>
    )
}

export default NoRecordFound;